import type {
  AvailableOn,
  WeekDays,
} from 'app/components/commons/Experience/Availability/utils';
import type { OpeningHours } from 'app/components/commons/Hotel/Types';
import type { Dayjs } from 'app/utils/dayjs';

import type { Picture } from './picture';

export type ExperiencesFormQueryParam = {
  search?: string;
  limit?: number;
  sorting?: string;
  offset?: number;
  isPublished?: boolean;
  isStaycationExp?: boolean;
};

export type ClosingPeriod = {
  start: string;
  end: string;
};

export type Experience = {
  id: number;
  categoryId: number;
  coverPicture?: Picture;
  emoji: Picture | null;
  description: string | null;
  hotelId?: number;
  countryId?: number;
  included: boolean;
  name: string | null;
  pictures: Picture[];
  price: number;
  priceDescription: string | null;
  purchasePrice?: number;
  publicPrice?: number;
  openingHours: OpeningHours | null;
  published: boolean;
  brand: string | null;
  roomServiceAvailable: boolean;
  roomServiceIncluded: boolean;
  spaceIds: number[];
  accessMode: string | null;
  roomServicePrice: number | null;
  quantity: number | null;
  quantityDescription: string | null;
  duration: number | null;
  durationDescription: string | null;
  time: string | null | Dayjs;
  locations: string | null;
  closingPeriods: [Date, Date][];
  closedHoursBeforeCheckin: number | null;
  addOnLimitAvailabilityUnit: 'hours' | 'days';
  maxQuantity: number | null;
  availableDays: WeekDays[];
  availableDayLimits: AvailableOn[];
  availableDates: string[];
  tagline?: string;
  menu?: string | null;
  treatmentList?: string | null;
  importantInformations?: string;
  isAlwaysIncludedWithNight: boolean;
};

export type ExperienceListElement = Experience & {
  category: ExperienceCategory;
};

export type ExperienceCategory = {
  id: number;
  name: string;
  pictureId?: number;
  parentId?: number;
  experienceType?: string;
  brand: boolean;
  duration: boolean;
  time: boolean;
  quantityTitle: boolean;
  locations: boolean;
  accessMode: boolean;
  price: boolean;
  priceDescription: boolean;
  quantity: boolean;
  quantityDescription: boolean;
  openingHours: ExperienceFieldType;
  roomService: boolean;
  spaces: boolean;
  menu: boolean;
  treatmentList: boolean;
  canBeStaycationExperiences: boolean;
};

export enum ExperienceFieldType {
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  OPTIONAL = 'OPTIONAL',
  MANDATORY = 'MANDATORY',
}

export enum ExperienceType {
  HOTEL = 'HOTEL',
  STAYCATION = 'STAYCATION',
}
